<template>
    <div class="wl">
        <header class="g-hd">
            物流配送回款报表
        </header>
        <div class="subHd f-dfsb">
            <div class="description" @click="isShowHelp = true">数据说明 <img src="../assets/yywl/question.png" alt=""></div>
            <div class="switch" @click="tags" :class="{place : isSwitch}">
                <!-- <transition> -->
                <div class="time" :class="{move : isSwitch}" @click.stop="tags2">
                    <input v-if="!isSwitch" class="timeInput" type="text" v-model="message" @click="show = true;" readonly="readonly">
                    <input v-else class="timeInput" type="text" v-model="message2" @click="showTwo = true;" readonly="readonly">
                </div>
                <!-- </transition> -->
            </div>
        </div>
        <ul class="u-list totalList">
            <li>
                <div class="num">{{data.TOTAL_DELIVERY_NUM /10000 | moneyP}}</div>
                <div class="tt">配送总额(万)</div>
            </li>
            <li>
                <div class="num">{{data.AMOUNT_DELIVERED /10000 | moneyP}}</div>
                <div class="tt">已配送额(万)</div>
            </li>
            <li>
                <div class="num">{{data.COMPLETION_RATE}}%</div>
                <div class="tt">完成率</div>
            </li>
        </ul>
        <section class="m-card">
            <div class="hd">
                <i class="line"></i>现结客户
            </div>

            <ul class="u-list itemList">
                <li>
                    <div class="num">{{data.CURRENT_CUSTOMER_DISTRIBUTION /10000 | moneyP }}</div>
                    <div class="tt">配送额(万)</div>
                </li>
                <li>
                    <div class="num">{{data.CURRENT_CUSTOMER_RECEIVED /10000 | moneyP}}</div>
                    <div class="tt">已收总额(万)</div>
                </li>
                <li>
                    <div class="num">{{(data.CURRENT_CUSTOMER_RECEIVED / data.CURRENT_CUSTOMER_DISTRIBUTION)*100 | moneyP}}%</div>
                    <div class="tt">完成率</div>
                </li>
            </ul>

            <van-collapse v-model="activeNames">
                <van-collapse-item name="1">
                    <template #title>
                        <div class="collapseTT">现结客户支付明细
                        </div>
                    </template>
                    <ul class="payType">
                        <li>
                            <div>支付方式</div>
                            <div>金额(万) </div>
                            <div>占比</div>
                        </li>
                        <li v-for="item in payDetails" :key="item.id">
                            <div>{{item.PAY_MODE }}</div>
                            <div>{{item.PAY_AMOUNT /10000 | moneyP}}</div>
                            <div>{{(item.PAY_AMOUNT/data.CURRENT_CUSTOMER_RECEIVED)*100 | moneyP}}%</div>
                        </li>
                    </ul>
                </van-collapse-item>

            </van-collapse>
            <ul class="u-list itemList2">
                <li>
                    <div class="num">{{data.CURRENT_CUSTOMER_NUM}}</div>
                    <div class="tt">现结客户(户)</div>
                </li>
                <li>
                    <div class="num">{{data.CURRENT_CUSTOMER_FINISHED}}</div>
                    <div class="tt">已配送(户)</div>
                </li>
                <li>
                    <div class="num">{{(data.CURRENT_CUSTOMER_FINISHED/data.CURRENT_CUSTOMER_NUM)*100| moneyP}}%</div>
                    <div class="tt">完成率</div>
                </li>
            </ul>
        </section>
        <div class="bar"></div>
        <section class="m-card">
            <div class="hd">
                <i class="line"></i>账期客户
            </div>
            <ul class="u-list itemList">
                <li>
                    <div class="num">{{data.ACCOUNT_CUSTOMER_DISTRIBUTION /10000 | moneyP}}</div>
                    <div class="tt">配送额(万)</div>
                </li>
                <li>
                    <div class="num">{{data.ACCOUNT_CUSTOMER_RECEIVED /10000 | moneyP}}</div>
                    <div class="tt">已收总额(万)</div>
                </li>
                <li>
                    <div class="num">{{(data.ACCOUNT_CUSTOMER_RECEIVED/data.ACCOUNT_CUSTOMER_DISTRIBUTION)*100| moneyP}}%</div>
                    <div class="tt">完成率</div>
                </li>
            </ul>
            <ul class="u-list itemList2">
                <li>
                    <div class="num">{{data.ACCOUNT_CUSTOMER_NUM}}</div>
                    <div class="tt">账期客户(户) </div>
                </li>
                <li>
                    <div class="num">{{data.ACCOUNT_CUSTOMER_FINISHED}}</div>
                    <div class="tt">已配送(户)</div>
                </li>
                <li>
                    <div class="num">{{(data.ACCOUNT_CUSTOMER_FINISHED/data.ACCOUNT_CUSTOMER_NUM)*100| moneyP}}%</div>
                    <div class="tt">完成率</div>
                </li>
            </ul>
        </section>

        <div class="bar"></div>
        <section class="m-card">
            <div class="hd">
                <i class="line"></i>金额-趋势分析
            </div>
            <div class="chartBox">
                <ve-line :extend="chartExtend" :data="chartData" height="220px"></ve-line>
            </div>
        </section>
        <div class="bar"></div>
        <section class="m-card">
            <div class="hd">
                <i class="line"></i>客户数-趋势分析
            </div>
            <div class="chartBox">
                <ve-line :extend="chartExtend" :data="chartData2" height="220px"></ve-line>
            </div>
        </section>
        <div class="bar"></div>
        <section class="collapseBox">
            <van-collapse v-model="activeNames2">
                <van-collapse-item name="1">
                    <template #title>
                        <div class="f-dfsb collapseTT">
                            <span>折扣&赊账</span>
                            <div class="detail">
                                <span>金额：{{data.DISCOUNT_AMOUNT + data.CREDIT_AMOUNT | moneyP}} </span>
                                <!-- <span>比率：{{(data.DISCOUNT_AMOUNT + data.CREDIT_AMOUNT)/data.TOTAL_DELIVERY_NUM | moneyP}}% </span> -->
                            </div>
                        </div>
                    </template>
                    <ul class="disList">
                        <li>
                            <div>
                                <div class="num">{{data.DISCOUNT_AMOUNT | moneyP}}</div>
                                <div class="tt">折扣金额(元)</div>
                            </div>
                            <div>
                                <div class="num">{{data.DISCOUNT_NUMBER }}</div>
                                <div class="tt">折扣笔数</div>
                            </div>
                        </li>
                        <li>
                            <div>
                                <div class="num">{{data.CREDIT_AMOUNT | moneyP}}</div>
                                <div class="tt">赊账金额(元)</div>
                            </div>
                            <div>
                                <div class="num">{{data.CREDIT_NUMBER}}</div>
                                <div class="tt">赊账笔数</div>
                            </div>
                        </li>
                    </ul>
                </van-collapse-item>
                <van-collapse-item name="2">
                    <template #title>
                        <div class="f-dfsb collapseTT">
                            <span>退货&返仓</span>
                            <div class="detail">
                                <span>金额：{{data.CANCEL_AMOUNT + data.RETURN_AMOUNT | moneyP}} </span>
                                <!-- <span>比率：{{(data.CANCEL_AMOUNT + data.RETURN_AMOUNT)/data.TOTAL_DELIVERY_NUM | moneyP}}% </span> -->
                            </div>
                        </div>
                    </template>
                    <ul class="disList">
                        <li>
                            <div>
                                <div class="num">{{data.CANCEL_AMOUNT | moneyP}}</div>
                                <div class="tt">退货金额(元)</div>
                            </div>
                            <div>
                                <div class="num"> {{data.CANCEL_NUMBER}}</div>
                                <div class="tt">退货笔数</div>
                            </div>
                        </li>
                        <li>
                            <div>
                                <div class="num">{{data.RETURN_AMOUNT | moneyP}}</div>
                                <div class="tt">返仓金额(元)</div>
                            </div>
                            <div>
                                <div class="num">{{data.RETURN_NUMBER}}</div>
                                <div class="tt">返仓笔数</div>
                            </div>
                        </li>
                    </ul>
                </van-collapse-item>
            </van-collapse>
        </section>
        <div class="bar"></div>
        <section class="m-card m-card2">
            <div class="hd">
                <i class="line"></i>线路分析
            </div>
            <ul class="analysisList">
                <li>
                    <div class="item1">总线路数</div>
                    <div class="item2">客户数</div>
                    <div class="item3">已送</div>
                    <div class="item4">返仓</div>
                    <div class="item5">完成率</div>
                </li>
                <li>
                    <div class="item1">{{data.LINES_NUM}}</div>
                    <div class="item2">{{data.CUSTOMER_NUM}}</div>
                    <div class="item3">{{data.FINISHED_NUM}}</div>
                    <div class="item4">{{data.RETURN_NUMBER}}</div>
                    <div class="item5">{{data.DELIVERY_FINISH_RATE}}%</div>
                </li>
            </ul>
            <van-collapse v-model="activeNames3">
                <van-collapse-item name="1">
                    <template #title>
                        <div class="collapseTT">线路分析明细
                        </div>
                    </template>
                    <ul class="payType payType2">
                        <li>
                            <div class="item1">线路</div>
                            <div class="item2">客户数 </div>
                            <div class="item3">已送</div>
                            <div class="item4">返仓</div>
                            <div class="item5">完成率</div>
                        </li>
                        <li v-for="item in lineDetails" :key="item.id">
                            <div class="item1">{{item.LINE_NAME}}</div>
                            <div class="item2">{{item.CUSTOMER_NUM}}</div>
                            <div class="item3">{{item.FINISHED_NUM}}</div>
                            <div class="item4">{{item.RETURN_NUM}}</div>
                            <div class="item5">{{item.FINISH_RATE}}%</div>
                        </li>
                    </ul>
                </van-collapse-item>

            </van-collapse>
        </section>
        <section class="m-card m-card3">
            <div class="hd">
                <i class="line"></i>配送员分析
            </div>
            <ul class="analysisList analysisList2">
                <li>
                    <div class="item1">配送人数</div>
                    <div class="item2">客户数</div>
                    <div class="item3">已送</div>
                    <div class="item4">返仓</div>
                    <div class="item5">完成率</div>
                </li>
                <li>
                    <div class="item1">{{data.DELIVERYMAN_NUM}}</div>
                    <div class="item2">{{data.CUSTOMER_NUM}}</div>
                    <div class="item3">{{data.FINISHED_NUM}}</div>
                    <div class="item4">{{data.RETURN_NUMBER}}</div>
                    <div class="item5">{{data.DELIVERY_FINISH_RATE}}%</div>
                </li>
            </ul>
            <van-collapse v-model="activeNames4">
                <van-collapse-item name="2">
                    <template #title>
                        <div class="collapseTT">配送员分析明细
                        </div>
                    </template>
                    <ul class="payType">
                        <li>
                            <div>线路</div>
                            <div>客户数 </div>
                            <div>已送</div>
                            <div>返仓</div>
                            <div>完成率</div>
                        </li>
                        <li v-for="item in manDetails" :key="item.id">
                            <div>{{item.USER_NAME}}</div>
                            <div>{{item.CUSTOMER_NUM}}</div>
                            <div>{{item.FINISHED_NUM}}</div>
                            <div>{{item.RETURN_NUM}}</div>
                            <div>{{item.FINISH_RATE}}%</div>
                        </li>

                    </ul>
                </van-collapse-item>

            </van-collapse>
        </section>
        <van-popup v-model="show" position="bottom">
            <van-datetime-picker show-toolbar v-model="currentDate" type="date" :min-date="minDate" :max-date="maxDate" @confirm="onConfirm" @cancel="onCancel" />
        </van-popup>
        <van-popup v-model="showTwo" position="bottom">
            <van-datetime-picker show-toolbar v-model="currentDate" type="year-month" :min-date="minDate" :max-date="maxDateT" @confirm="onConfirmT" @cancel="onCancelT" />
        </van-popup>
        <van-popup class="helpPopup" v-model="isShowHelp">
            <div class="tt">数据说明</div>
            <ul class="helpBox">
                <li>已收金额=现结客户收款+账期客户收货款</li>
                <li>完成率=已收金额/(配送总额-折扣总额-退货总额)*100%</li>
                <li>
                    <p>现结客户支付类型区分： </p>
                    <p>
                        <span class="mark">微信/支付宝</span>支付实时到账</p>
                    <p>
                        <span class="mark">POS机刷卡</span>非实时到账,银行对账明细需T+1日可确认</p>
                    <p>
                        <span class="mark">直接打款</span>非实时到账,业务员确认到账情况</p>
                </li>
                <li>
                    <p>折扣金额=商家订单优惠+现场优惠金额 </p>
                    <p>赊账金额=商家订单的赊账金额</p>
                    <p>退货金额=商家订单退货部分金额</p>
                    <p>返仓金额=商家订单返仓部分金额</p>
                </li>
            </ul>
        </van-popup>
    </div>
</template>

<script>
import api from "@/axios/api";
import { mapGetters, mapActions } from "vuex";
export default {
    computed: {
        ...mapGetters(["token"])
    },
    watch: {
        token: {
            immediate: true,
            handler: function(val) {
                if (val) {
                    this.getmanagerreport(this.time1);;
                }
            }
        }
    },
    data() {
        return {
            activeNames: ["0"],
            activeNames2: ["0"],
            activeNames3: ["0"],
            activeNames4: ["0"],
            data: {},
            payDetails: [],
            lineDetails: [],
            manDetails: [],
            isSwitch: false,
            show: false,
            showTwo: false,
            isShowHelp: false,
            time1: (function() {
                var date = new Date(
                    new Date().getTime() - 24 * 60 * 60 * 1000 * 1
                );
                let year = date.getFullYear();
                let month = date.getMonth() + 1;
                let day = date.getDate();
                if (month >= 1 && month <= 9) {
                    month = "0" + month;
                }
                if (day >= 0 && day <= 9) {
                    day = "0" + day;
                }
                return year + "-" + month + "-" + day;
            })(),
            time2: (function() {
                let year = new Date().getFullYear();
                let month = new Date().getMonth();
                if (month == 0) {
                    year = year - 1;
                    month = 12;
                } else if (month >= 1 && month <= 9) {
                    month = "0" + month;
                }
                return year + "-" + month;
            })(),
            message: new Date(
                new Date(new Date().toLocaleDateString()).getTime() -
                    24 * 60 * 60 * 1000 * 1
            ).toLocaleDateString(),
            message2: (function() {
                let year = new Date().getFullYear();
                let month = new Date().getMonth();
                if (month == 0) {
                    year = year - 1;
                    month = 12;
                }
                return year + "/" + month;
            })(),

            // new Date().getFullYear() + "/" + (new Date().getMonth() ),
            currentDate: new Date(
                new Date().getTime() - 24 * 60 * 60 * 1000 * 1
            ),
            currentDate2: (function() {
                let year = new Date().getFullYear();
                let month = new Date().getMonth();
                if (month == 0) {
                    year = year - 1;
                    month = 12;
                }
                return new Date(year + "/" + month);
            })(),
            minDate: new Date("2020-07-01"),
            maxDate: new Date(
                new Date(new Date().toLocaleDateString()).getTime() -
                    24 * 60 * 60 * 1000 * 1
            ),
            minDateT: new Date("2020-07"),
            maxDateT: (function() {
                let year = new Date().getFullYear();
                let month = new Date().getMonth();
                if (month == 0) {
                    year = year - 1;
                    month = 12;
                } else if (month >= 0 && month <= 9){
                    month = "0" + month;
                }
                return new Date(year + "-" + month );
            })(),
            chartExtend: {
                grid: {
                    x: 30,
                    y: 40,
                    x2: 30,
                    y2: 17
                },
                series: {
                    symbol: "none"
                    // lineStyle: {
                    //     normal: {
                    //         color: "#77E49D"
                    //     }
                    // }
                },
                xAxis: {
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: "#dedede"
                        }
                    },
                    axisLabel: {
                        textStyle: {
                            color: "#a6a6a6",
                            fontSize: 13
                        }
                    }
                },
                yAxis: {
                    axisTick: {
                        //y轴刻度线
                        show: false
                    },
                    axisLabel: {
                        textStyle: {
                            color: "#a6a6a6",
                            fontSize: 13
                        }
                    },
                    splitLine: {
                        //网格线
                    }
                }
            },
            chartData: {
                columns: [],
                rows: []
            },
            chartData2: {
                columns: [],
                rows: []
            }
        };
    },
    filters: {},
    mounted() {
        
        
    },
    methods: {
        tags() {
            this.isSwitch = !this.isSwitch;
            if (this.isSwitch) {
                this.getmanagerreport(this.time2);
            } else {
                this.getmanagerreport(this.time1);
            }
        },
        tags2() {
            this.isSwitch = this.isSwitch;
        },
        getmanagerreport(time) {
            let params = {
                SEARCH_TIME: time
            };
            api.getmanagerreport(params).then(res => {
                this.data = res[0].data;
                this.payDetails = res[0].payDetails;
                this.lineDetails = res[0].lineDetails;
                this.manDetails = res[0].manDetails;
                this.chartData.columns = res[0].co1umns1;
                this.chartData.rows = res[0].rows1;
                this.chartData2.columns = res[0].co1umns2;
                this.chartData2.rows = res[0].rows2;
            });
        },
        onConfirm(picker, value, index) {
            this.show = false;
            let year = this.currentDate.getFullYear();
            let month = this.currentDate.getMonth() + 1;
            let date = this.currentDate.getDate();

            this.message = year + "/" + month + "/" + date;
            if (month >= 1 && month <= 9) {
                month = "0" + month;
            }
            if (date >= 0 && date <= 9) {
                date = "0" + date;
            }
            this.time1 = year + "-" + month + "-" + date;
            this.getmanagerreport(this.time1);
        },
        onCancel() {
            this.show = false;
        },
        onConfirmT(picker, value, index) {
            this.showTwo = false;
            // let year = this.currentDate2.getFullYear();
            // let month = this.currentDate2.getMonth() + 1;
            // this.message2 = year + "/" + month;
            // if (month >= 1 && month <= 9) {
            //     month = "0" + month;
            // }
            // this.time2 = year + "-" + month;
            // this.getmanagerreport(this.time2);
        },
        onCancelT() {
            this.showTwo = false;
        }
    }
};
</script>

<style lang="less" scoped>
.wl {
    padding-bottom: 20vw;
}
.g-hd {
    padding: 4vw;
    font-size: 16px;
    color: #2c2c2c;
    text-align: left;
    border-bottom: 1px solid #e6e6e6;
}
.subHd {
    padding: 4vw;
    .description {
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #477aff;
        img {
            width: 4vw;
            margin-left: 2vw;
        }
    }
    .switch {
        width: 40vw;
        height: 10.67vw;
        background: #f0f0f0 url(../assets/yywl/sl.png) no-repeat;
        background-position: 90% 50%;
        background-size: 6vw;
        border-radius: 6vw;
        transition: all 0.5s ease;
        .time {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 26.67vw;
            height: 10.67vw;
            padding: 0 2vw;
            font-size: 14px;
            color: #fff;
            background-color: #477aff;
            border-radius: 6vw;
            transition: all 0.5s ease;
            box-sizing: border-box;
            .timeInput {
                width: 100%;
                background-color: inherit;
                border: none;
                text-align: center;
            }
        }
        .move {
            transform: translateX(13.33vw);
        }
    }
    .place {
        background-position: 10% 50%;
    }
}
.u-list {
    display: flex;
    li {
        flex: 1;
        text-align: center;
    }
}
.totalList {
    li {
        padding: 7.4vw 0 6.7vw;
        background-color: #477aff;

        .num {
            margin-bottom: 2vw;
            font-size: 23px;
            color: #fff;
        }
        .tt {
            font-size: 14px;
            color: #bbdefc;
        }
    }
    li:first-child {
        background-color: #92c619;
        .tt {
            color: #d5fcbb;
        }
    }
}
.itemList {
    li {
        padding: 4.2vw 0 3.7vw 0;
        background-color: #f4f4f4;

        .num {
            margin-bottom: 1vw;
            font-size: 16px;
            color: #2c2c2c;
        }
        .tt {
            font-size: 14px;
            color: #a6a6a6;
        }
    }
    li:first-child {
        background-color: #92c619;
        .num {
            color: #fff;
        }
        .tt {
            color: #d5fcbb;
        }
    }
}
.itemList2 {
    background: #fff;
    li {
        padding: 4.2vw 0 3.7vw 0;
        .num {
            margin-bottom: 1vw;
            font-size: 16px;
            color: #2c2c2c;
            font-weight: 500;
        }
        .tt {
            font-size: 14px;
            color: #a6a6a6;
        }
    }
}
.m-card {
    .hd {
        display: flex;
        align-items: center;
        line-height: 1;
        padding: 4.8vw 4vw;
        font-size: 16px;
        color: #2c2c2c;
        background: #fff;
        .line {
            display: inline-block;
            width: 0.9vw;
            height: 3.4vw;
            margin-right: 3.4vw;
            background: url("../assets/yywl/line.png") no-repeat;
            background-size: 100%;
        }
    }
    /deep/.van-cell {
        padding: 4vw;
        border-bottom: 1px solid #e5e5e5;
    }
    /deep/.van-collapse-item__content {
        background-color: #ecf7ff;
    }
    /deep/.collapseTT {
        font-size: 16px;
    }
}
.m-card2 {
    /deep/.van-cell {
        padding: 3.2vw 4vw;
        border-bottom: none;
        background-color: #ecf7ff;
        /deep/.van-cell__right-icon {
            font-size: 12px;
            color: #5fb8f8;
        }
        /deep/.van-icon-arrow::before {
            content: "\F0A1";
        }
    }
    .collapseTT {
        text-align: right;
        font-size: 13px;
        color: #5fb8f8;
    }
}
.m-card3 {
    /deep/.van-cell {
        padding: 3.2vw 4vw;
        border-bottom: none;
        background-color: #f2f9e1;
        /deep/.van-cell__right-icon {
            font-size: 12px;
            color: #92c619;
        }
        /deep/.van-icon-arrow::before {
            content: "\F0A1";
        }
    }
    .collapseTT {
        text-align: right;
        font-size: 13px;
        color: #92c619;
    }
    /deep/.van-collapse-item__content {
        background-color: #f2f9e1;
    }
    .payType {
        li:first-child {
            color: #92c619;
            border-bottom: 1px solid #92c619;
        }
    }
}
.collapseBox {
    /deep/.van-cell {
        padding: 4vw;
        border-bottom: 1px solid #e5e5e5;
    }
    .collapseTT {
        font-size: 16px;
        color: #2c2c2c;
        .detail {
            font-size: 14px;
            color: #a6a6a6;
        }
    }
    /deep/.van-collapse-item__content {
        padding: 0;
    }
    .disList {
        li {
            display: flex;
            justify-content: space-between;
            padding: 2vw 0;
            background-color: #f4f4f4;
            div {
                width: 40vw;
                text-align: center;
                .num {
                    font-size: 16px;
                    color: #2c2c2c;
                }
                .tt {
                    font-size: 14px;
                    color: #a6a6a6;
                }
            }
        }
        li:first-child {
            margin-bottom: 2px;
        }
    }
}
.bar {
    height: 1.6vw;
    background: #f4f4f4;
}
.payType {
    padding: 0.6vw 2vw;
    background-color: #fff;
    border-radius: 6px;
    li {
        display: flex;
        padding: 2.6vw 0;
        line-height: 1;
        color: #2c2c2c;
        text-align: center;
        div {
            flex: 1;
            font-size: 14px;
        }
        div:first-child {
            padding-left: 3.2vw;
            text-align: left;
        }
    }
    li:first-child {
        color: #5fb8f8;
        border-bottom: 1px solid #5fb8f8;
    }
}
.payType2 {
    li {
        div {
            flex: auto;
            font-size: 14px;
        }
        .item1 {
            width: 24vw;
        }
        .item2 {
            width: 19vw;
        }
        .item3 {
            width: 19vw;
        }
        .item4 {
            width: 19vw;
        }
        .item5 {
            width: 19vw;
        }
    }
}
.analysisList {
    padding: 3.2vw 0 1.6vw 0;
    background-color: #6e91ed;
    li {
        display: flex;
        text-align: center;
        color: #fff;
        .item1 {
            width: 25vw;
        }
        .item2 {
            width: 20vw;
        }
        .item3 {
            width: 15vw;
        }
        .item4 {
            width: 15vw;
        }
        .item5 {
            width: 25vw;
        }
        div {
            line-height: 1;
            padding: 4vw 0 1.3vw 0;
            border-right: 1px solid rgba(255, 255, 255, 0.2);
        }
        div:last-child {
            border-right: none;
        }
    }
    li:first-child {
        color: #bbdefc;
        border-bottom: 1px solid rgba(255, 255, 255, 0.2);
        div {
            padding: 1.3vw 0 4vw 0;
        }
    }
}
.analysisList2 {
    background-color: #92c619;
    li:first-child {
        color: #d5fcbb;
    }
}
.chartBox {
    background: #fff;
}
.helpPopup {
    width: 85vw;
    padding: 4vw;
    border-radius: 6px;
    background-color: #ecf7ff;
    .tt {
        margin-bottom: 4vw;
        font-size: 16px;
        text-align: center;
        color: #477aff;
    }
    .helpBox {
        li {
            padding: 3vw 2vw;
            margin-bottom: 2vw;
            border-radius: 6px;
            font-size: 13px;
            color: #616161;
            background-color: #fff;
            text-align: left;
            p {
                margin: 0;
                .mark {
                    font-weight: 700;
                    color: #477aff;
                }
            }
        }
    }
}
// .v-enter,
// .v-leave-to {
//     width: 0;
//     transform: translateX(13.33vw);
// }

// .v-enter-active {
//     transition: all 0.5s ease;
// }
// .v-leave-active {
//     transition: all 0.5s ease;
// }
</style>





// WEBPACK FOOTER //
// src/yywl/managementReport.vue